import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'

// 根据环境配置 API 地址
// 开发环境：使用代理路径 /api/service.php（会被代理到 http://localhost:8000/service.php）
// 生产环境：使用环境变量配置的完整 URL
const BASEURL = process.env.VUE_APP_API_BASE_URL || (
    process.env.NODE_ENV === 'production' 
        ? 'https://ftsci.com.cn/service.php' // 默认生产环境地址（请通过 .env.production 配置）
        : '/api/service.php' // 开发环境使用代理路径
)

// 调试：输出当前使用的 API 地址（生产环境不输出）
if (process.env.NODE_ENV !== 'production') {
    console.log('当前环境:', process.env.NODE_ENV)
    console.log('API 地址:', BASEURL)
}

// 添加请求拦截器
axios.interceptors.request.use(
    function (config) {
        // 调试：显示实际请求的 URL
        console.log('请求 URL:', config.url)
        console.log('完整请求配置:', config)
        return config
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
axios.interceptors.response.use(
    function (res) {
        // 确保返回的数据是有效的
        if (res && res.data) {
            return res.data
        }
        // 如果 res.data 不存在，返回一个默认的有效对象
        return res || { code: 200, msg: '', data: null }
    },
    function (error) {
        console.error('API请求错误:', error)
        
        // 处理不同类型的错误
        let errorMsg = '接口报错了~'
        if (error.response) {
            // 服务器返回了错误状态码
            errorMsg = `服务器错误: ${error.response.status}`
        } else if (error.request) {
            // 请求已发出，但没有收到响应（可能是网络问题或内网穿透问题）
            errorMsg = '网络连接失败，请检查网络或服务器地址'
        } else {
            // 其他错误
            errorMsg = error.message || '接口报错了~'
        }
        
        // 只在开发环境显示详细错误
        if (process.env.NODE_ENV !== 'production') {
            console.error('详细错误信息:', {
                message: error.message,
                response: error.response,
                request: error.request,
                config: error.config
            })
        }
        
        // 返回一个有效的响应对象，避免后续代码访问 undefined.code 报错
        return Promise.resolve({
            code: 500,
            msg: errorMsg,
            data: null
        })
    }
)

export function api(action, method, data) {
    let reqUrl = BASEURL //请求地址
    let reqMethod = method ? method.toLowerCase() : 'post' //请求方式
    let reqData = {
        action: action,
        userId: store.state.vuex_userId || '',
        token: store.state.vuex_token || '',
        ...data,
    }

    let otherConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    }

    const formData = new URLSearchParams()
    Object.keys(reqData).forEach((key) => {
        const value = reqData[key]
        formData.append(key, value === undefined || value === null ? '' : value)
    })

    if (reqMethod == 'get') {
        return axios({
            url: reqUrl,
            method: reqMethod,
            params: reqData,
            timeout: 30000, // 30秒超时
            ...otherConfig,
        })
    } else if (reqMethod == 'post') {
        return axios({
            url: reqUrl,
            method: reqMethod,
            data: formData.toString(),
            timeout: 30000, // 30秒超时
            ...otherConfig,
        })
    }
}

export function apiGet(action, data) {
    let reqUrl = BASEURL //请求地址
    let obj = {
        userId: store.state.vuex_userId || '',
        token: store.state.vuex_token || '',
        ...data,
    }
    let reqData = {
        action: action,
        ...obj,
    }

    let otherConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    }

    return axios({
        url: reqUrl,
        method: 'get',
        params: reqData,
        timeout: 30000, // 30秒超时
        ...otherConfig,
    })
}

export function apiPost(action, data) {
    return api(action, 'post', data)
}

export function apiUpload(file) {
    let reqUrl = BASEURL //请求地址

    let otherConfig = {
        headers: {
            'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime(),
        },
    }

    let formData = new FormData()
    formData.append('img', file)

    return axios({
        url: reqUrl,
        method: 'post',
        data: formData,
        params: {
            action: 'index_localUpload',
            userId: store.state.vuex_userId || '',
            token: store.state.vuex_token || '',
        },
        timeout: 60000, // 上传文件超时时间更长，60秒
        ...otherConfig,
    })
}

export function product_importProduct(file) {
    let reqUrl = BASEURL //请求地址

    let otherConfig = {
        headers: {
            'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime(),
        },
    }

    let formData = new FormData()
    formData.append('file', file)

    return axios({
        url: reqUrl,
        method: 'post',
        data: formData,
        params: {
            action: 'product_importProduct',
            userId: store.state.vuex_userId || '',
            token: store.state.vuex_token || '',
        },
        timeout: 60000, // 上传文件超时时间更长，60秒
        ...otherConfig,
    })
}
